import type { App } from "vue"
import type { ModuleDefinition, ModuleOptions } from "@core/types/module"

const energyManagerModule: ModuleDefinition = {
    name: "energy-manager",

    install(_app: App, _options: ModuleOptions): void {
        // Initialisation du module
    },
}

export default energyManagerModule
